import React, { useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import PageLayout from '../../common/PageLayout'
import { useScheduledPromptById } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import EditDigest from './EditDigest'
import EditSchedule from './EditSchedule'

function EditScheduleView () {
  const history = useHistory()
  const { scheduleId } = useParams()
  const { data, isLoading } = useScheduledPromptById(scheduleId, {
    lastResponse: true
  })

  const onComplete = useCallback(() => {
    history.push(`/denali-ai/schedules/${scheduleId}`)
  }, [history, scheduleId])

  const onCancel = useCallback(() => {
    history.go(-1)
  }, [history])

  const scheduledPrompt = data?.scheduledPrompt || {}

  return (
    <PageLayout variant='constrained'>
      {isLoading ? (
        <Loading />
      ) : scheduledPrompt.isDigest ? (
        <EditDigest
          scheduledPrompt={data.scheduledPrompt}
          onComplete={onComplete}
          onCancel={onCancel}
        />
      ) : (
        <EditSchedule
          scheduledPrompt={data.scheduledPrompt}
          onComplete={onComplete}
          onCancel={onCancel}
        />
      )}
    </PageLayout>
  )
}

export default EditScheduleView
